export enum TransactionType {
  lettings = 'lettings',
  sales = 'sales',
}

export interface TransactionSpace {
  created_at: string;
  floor: string;
  id: number;
  property_id: number;
  size: {
    metric: string | null;
    value: string | null;
    value_sqft: number | null;
  };
  size_metric: string | null;
  size_sqft: string | null;
  unit: string | null;
  updated_at: string;
}

export interface TransactionLeaseSpaceContent {
  available: unknown;
  building_types: string | null;
  business_rate: unknown;
  condition_string: string;
  condition: string;
  epc: unknown;
  estate_charge: unknown;
  estimated: null;
  fitout_concept: null;
  fitted_space: null;
  floor_string: string;
  floor: string;
  grade_space: string;
  lease: unknown;
  leasehold_details: unknown;
  part_floor: boolean;
  size: {
    measure: string;
    metric: Metric;
    value: number;
    value_sqft: number;
    value_sqft_string: string;
    value_sqm: number;
    value_sqm_string: string;
    value_string: string;
  };
  total_month_string: string;
  total_month: number;
  total_sqft_string: string;
  total_sqft: number;
  total_year_string: string;
  total_year: number;
  unit: string;
}

export interface TransactionLeaseSpace {
  content: TransactionLeaseSpaceContent;
  created_at: string;
  external_ref_1: null;
  floor_description: string | null;
  floor_identifier: string;
  floor_name_string: string;
  floor_string: string;
  id: number;
  object_id: number;
  object_type: string;
  part_floor: boolean;
  sort: null;
  space: TransactionSpace;
  updated_at: string;
}

export interface IEpc {
  band: string;
  epc_string: string;
  exempt: boolean | string;
  exempt_reason: string;
  multiple: string;
  multiple_band: string;
  multiple_value: string;
  string: string;
  value: string;
}

export interface IPotentialEpc {
  band: null;
  multiple: boolean | null;
  multiple_band: string | null;
  multiple_value: string | null;
  value: string | null;
}

export interface IRentReviewEvent {
  from: string | null;
  to: string | null;
  comments: string | null;
}

export interface IPublishToRadius {
  details: {
    [key: string]: IPublishToRadiusDetails;
  };
  published: boolean;
  published_at: string | boolean;
  published_by_name: string | boolean;
  published_by_user_id: number | boolean;
  updated_at: string | boolean;
  updated_by_name: string | boolean;
  updated_by_user_id: number | boolean;
}

export interface IPublishToRadiusDetails {
  enabled: boolean;
  title: string;
}

export interface IPublishToAtlas {
  atlas_url: string | null;
  can_be_ranked: boolean;
  details: {
    [key: string]: IPublishToAtlasDetails;
  };
  errors?: {
    type: string;
    field: string;
    value: any;
    reason: string;
    message: string;
    atlas_field: string;
    atlas_reason: string | null;
  }[];
  published: boolean;
  published_at: string | boolean;
  published_by_name: string | boolean;
  published_by_user_id: number | boolean;
  updated_at: string | boolean;
  updated_by_name: string | boolean;
  updated_by_user_id: number | boolean;
}

export interface IPublishToAtlasDetails {
  enabled: boolean;
}

export interface TransactionSpace {
  created_at: string;
  floor: string;
  id: number;
  property_id: number;
  size: {
    metric: string | null;
    value: string | null;
    value_sqft: number | null;
  };
  size_metric: string | null;
  size_sqft: string | null;
  unit: string | null;
  updated_at: string;
}
